/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useMemo, useState } from 'react';
import {
  StyleSheet,
  View,
  TouchableOpacity,
  ActivityIndicator,
  Linking,
  Dimensions,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';
import Toast from 'react-native-toast-message';

import * as Layout from '@components/screen/Layout';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import Button from '@components/form/Button';
import MoreButton from '@components/navbar/MoreButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import { SociollaForm, SociollaSubmitButton } from '@components/sociolla/form';
import SociollaTabs from '@components/sociolla/SociollaTabs';
import PricelistDetail from '@components/setting/pricelist/PricelistDetail';
import PricelistProduct from '@components/setting/pricelist/PricelistProduct';
import PricelistLogs from '@components/setting/pricelist/PricelistLogs';
import ModalProduct from '@components/setting/pricelist/ModalProduct';
import ProgressBar from '@components/global/ProgressBar';
import StatusPicker from '@components/form/StatusPicker';
import ModalUpload from '@components/modal/ModalUpload';

import Colors from '@global/colors';
import { isWeb, isAndroid } from '@global/screens';
import { backSection, backSectionText } from '@/assets/styles/mainStyles';
import {
  buttonPrimary,
  buttonRounded,
  buttonFloating,
} from '@/assets/styles/buttonStyles';
import { showAlert } from '@/store/global';
import templateCsv from '@/assets/csv/template-import-add-product-pricelist';
//import { formik } from 'formik';

import useApi from '@/hooks/useApi';
import {
  getPriceRulesById,
  createPriceRules,
  updatePriceRulesStatus,
  updatePriceRulesProducts,
  deletePriceRule,
  bulkAddProductPriceRules,
} from '@api/ms-catalog';
import { exportCsv, getExportStatus } from '@api/ms-b2b';
import { showPopup } from '@/store/modal';
import { parseDate, changeTimeZone, hasNoAccess, sleep } from '@global/helpers';

const dimension = Dimensions.get('screen');

const validationSchema = Yup.object().shape({
  description: Yup.string()
    .trim()
    .required('Description is required.')
    .test(
      'alphabets',
      'Description must contain alphabets',
      (value) => /[^0-9]/.test(value) && /[a-zA-Z]/.test(value),
    )
    .label('Description'),
  currency: Yup.mixed().required('Currency is required.').label('Status'),
  market_type: Yup.mixed()
    .required('Market Type is required.')
    .label('Market Type'),
  from_date: Yup.string()
    .required('Start Date is required.')
    .label('Start Date'),
  to_date: Yup.string().required('End Date is required.').label('End Date'),
  taxes_type: Yup.mixed()
    .required('Taxes Types is required.')
    .label('Taxes Types'),
});

const tabs = [
  {
    label: 'Pricelist',
    value: 'pricelist',
  },
  {
    label: 'Price Log',
    value: 'pricelog',
  },
];

const tabsApps = [
  {
    label: 'Details',
    value: 'detail',
  },
  {
    label: 'Product',
    value: 'product',
  },
];

let form = null;

const AddProductSection = ({ isMobile = false, onCallback, onImport }) => {
  const { values } = useFormikContext();

  const isShowProductButton =
    values?.description &&
    values?.market_type &&
    values?.currency &&
    values?.from_date &&
    values?.to_date;

  return !isMobile ? (
    <View style={[styles.row, styles.productHeader]} key="header-add">
      <SociollaText
        type="medium"
        style={{
          fontSize: 12,
          letterSpacing: 1,
          color: Colors.black5,
        }}>
        PRODUCT
      </SociollaText>
      {isShowProductButton ? (
        <View style={{ flexDirection: 'row', gap: 5 }}>
          <Button
            buttonStyle={{
              ...buttonPrimary,
              ...buttonRounded,
              width: 135,
              backgroundColor: Colors.white,
              borderColor: Colors.grey10,
            }}
            title={
              <SociollaText
                type="medium"
                style={[styles.textAction, { color: Colors.black3 }]}>
                Import
              </SociollaText>
            }
            onPress={onImport}
          />
          <Button
            buttonStyle={{
              ...buttonPrimary,
              ...buttonRounded,
              width: 135,
              backgroundColor: Colors.white,
              borderColor: Colors.grey10,
            }}
            title={
              <SociollaText
                type="medium"
                style={[styles.textAction, { color: Colors.black3 }]}>
                Add Product
              </SociollaText>
            }
            onPress={onCallback}
          />
        </View>
      ) : (
        false
      )}
    </View>
  ) : isShowProductButton ? (
    <Button
      buttonStyle={{
        ...buttonRounded,
        ...{
          backgroundColor: Colors.white,
          borderColor: Colors.grey0,
          marginBottom: 10,
        },
      }}
      title={
        <SociollaText
          type="bold"
          style={{
            fontSize: 14,
            letterSpacing: 0.5,
            color: Colors.black,
          }}>
          Add Product
        </SociollaText>
      }
      onPress={onCallback}
    />
  ) : (
    false
  );
};

function PricelistDetailScreen(props) {
  const [isAddMode, setIsAddMode] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [empty, setEmpty] = useState(true);
  const [action, setAction] = useState('');
  const [tabActive, setTabActive] = useState('pricelist');
  const [tabActiveApps, setTabActiveApps] = useState('');
  const [rules, setRules] = useState({});
  const [productRules, setProductRules] = useState([]);
  const totalPage = 2;
  const [page, setPage] = useState(1);
  const [product, setProduct] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const prev_page = props?.route?.params?.prev_page;

  const dispatch = useDispatch();
  const productPriceRulesList = useSelector(
    (state) => state.modal.productPriceRulesList,
  );
  const productPriceRules = useSelector(
    (state) => state.modal.productPriceRules,
  );
  const userData = useSelector((state) => state.auth.user);
  const showImportModalAddProductPriceList = useSelector(
    (state) => state.modal.showImportModalAddProductPriceList,
  );

  const priceRules = useApi(getPriceRulesById);
  const editPriceRulesProduct = useApi(updatePriceRulesProducts);

  const showAddEdit = useMemo(() => {
    return (
      Boolean(
        ['superadmin', 'sales_admin', 'marketing_admin', 'general'].indexOf(
          userData.role?.code || '',
        ) > -1,
      ) && priceRules?.data?.status !== 'need_approval'
    );
  }, [userData, priceRules]);

  const showApproval = useMemo(() => {
    return (
      priceRules?.data?.current_approval == userData?.role?.code &&
      priceRules.data?.status === 'need_approval'
    );
  }, [userData, priceRules]);

  const hasAccessSoftDelete = !hasNoAccess([
    'superadmin',
    'general',
    'sales_admin',
    'marketing_admin',
  ]);

  const showDelete = useMemo(() => {
    return hasAccessSoftDelete && !priceRules?.data?.is_default;
  }, [hasAccessSoftDelete, priceRules]);

  const showStickyButton = !!(
    ['PricelistDetailScreen', 'PricelistEditScreen'].includes(
      props?.route?.name,
    ) &&
    Boolean(priceRules?.data?._id) &&
    showApproval
  );

  const goBack = () => {
    // From the edit form, step back to the detail view (not the list).
    if (isEditMode) {
      setIsEditMode(false);
      return;
    }
    if (prev_page == 'task') {
      props.navigation.navigate('TaskNotificationNavigator', {
        screen: 'TaskNotificationScreen',
        params: {
          task: true,
        },
      });
    } else {
      props.navigation.navigate('PricelistScreen');
    }
  };

  const updateStatus = async (status) => {
    try {
      const response = await updatePriceRulesStatus(
        props.route.params.id,
        status,
      );
      Toast.show({ text1: 'Price Rule Updated', type: 'success' });
      props.navigation.replace('PricelistEditScreen', {
        id: response.data.data._id,
        name: response.data.data.description,
      });
    } catch (e) {
      Toast.show({
        text1: 'Something Wrong, please try again.',
        type: 'error',
      });
    }
  };

  const handleSubmit = async (data, otherParam) => {
    const payload = { ...data };
    let saved = false;
    setDisabled(true);
    if (action === 'next') {
      setPage(page + 1);
      setDisabled(false);
      return;
    }
    if (productRules.length === 0 && action === 'request') {
      Toast.show({
        text1: 'Price list must have at least 1 product.',
        type: 'error',
      });
      setDisabled(false);
      return;
    }
    try {
      payload.from_date = parseDate(data.from_date, 'yyyy-MM-dd');
      payload.to_date = parseDate(data.to_date, 'yyyy-MM-dd');
      payload.currency = data.currency.value;
      payload.taxes_type = data.taxes_type.value;
      payload.market_type = {
        id: data.market_type.id,
        code: data.market_type.code,
      };
      if (data.market_type.cerebro_id) {
        payload.market_type['cerebro_id'] = data.market_type.cerebro_id;
      }
      if (action === 'add') {
        payload.status = 'draft';
      } else if (action === 'request') {
        payload.status = 'need_approval';
      }
      let title = '';
      if (isEditMode) {
        const response = await updatePriceRulesStatus(
          props.route.params.id,
          payload.status,
          payload,
        );
        // eslint-disable-next-line no-unused-vars
        title = 'Price Rule Updated';
        saved = response.data.data;
      } else {
        const response = await createPriceRules(payload);
        title = 'Price Rule Created';
        saved = response.data.data;
      }
      setIsEditMode(false);
      if (action === 'request') {
        dispatch(
          showAlert({
            show: true,
            title: 'Pricelist Submitted',
            description: 'Pricelist submitted and need approval.',
            isConfirm: false,
            onCallback: () => {
              if (saved) {
                props.navigation.replace('PricelistEditScreen', {
                  id: saved._id,
                  name: saved.description,
                });
              }
            },
          }),
        );
      } else {
        Toast.show({ text1: title, type: 'success' });
        if (saved) {
          props.navigation.replace('PricelistEditScreen', {
            id: saved._id,
            name: saved.description,
          });
        }
      }
    } catch (e) {
      console.log(e);
      setDisabled(false);
      Toast.show({ text1: `${e?.response?.data?.message}`, type: 'error' });
    }
  };

  const handleNeedApproval = async () => {
    try {
      setDisabled(true);
      setLoading(true);

      const payload = {
        status: 'need_approval',
      };

      const response = await updatePriceRulesStatus(
        props.route.params.id,
        payload.status,
      );

      if (response.data.data) {
        Toast.show({
          text1: 'Price Rule Submitted',
          type: 'success',
        });

        props.navigation.replace('PricelistEditScreen', {
          id: response.data.data._id,
          name: response.data.data.description,
        });
      }
    } catch (e) {
      console.log(e);
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  const productEditHandler = (data) => {
    const canEdit = Boolean(isAddMode || isEditMode);
    if (canEdit) {
      setProduct(data);
      dispatch(showPopup({ name: 'productPriceRules', value: true }));
    } else {
      setProduct(null);
    }
  };

  const onSelectedProduct = async (product, index = -1, data = null) => {
    const rules = [...productRules];
    if (index > -1) {
      if (data) {
        // Edit
        rules.splice(index, 1, {
          ...product.products,
          sales_price: product.sales_price,
          vat: product.vat,
        });
        try {
          const price_rules_id =
            data.price_rules_id || props?.route?.params?.id;
          if (price_rules_id) {
            await editPriceRulesProduct.request(
              price_rules_id,
              product.products.id,
              product.products.product_combination_id,
              { sales_price: product.sales_price, vat: product.vat },
            );
          }
        } catch (e) {
          console.log(e);
        }
        setProductRules(rules);
      } else {
        // Remove
        if (productRules.length === 1) {
          setEmpty(true);
          setProductRules([]);
        } else {
          setEmpty(false);
          setProductRules([
            ...productRules.slice(0, index),
            ...productRules.slice(index + 1),
          ]);
        }
      }
    } else {
      if (!Array.isArray(product)) {
        const checkProductNotSame = rules.filter(
          (pr) => pr.reference == product.products.reference,
        );
        if (checkProductNotSame.length) {
          Toast.show({
            text1: 'Cannot add duplicate product.',
            type: 'error',
          });
          return;
        }
      }
      if (Array.isArray(product)) {
        setProductRules(product);
        if (!data) {
          setEmpty(product.length === 0);
        }
      } else {
        rules.push({
          sales_price: product.sales_price,
          vat: product.vat,
          ...product.products,
        });
        try {
          if (!isEditMode) {
            const payload = {};
            const values = form?.values;
            payload.description = values.description;
            payload.status = 'draft';
            payload.from_date = parseDate(values.from_date, 'yyyy-MM-dd');
            payload.to_date = parseDate(values.to_date, 'yyyy-MM-dd');
            payload.currency = values.currency.value;
            payload.taxes_type = values.taxes_type.value;
            payload.market_type = {
              id: values.market_type.id,
              code: values.market_type.code,
            };
            if (values.market_type.cerebro_id) {
              payload.market_type['cerebro_id'] = values.market_type.cerebro_id;
            }
            payload.is_consignment = values.is_consignment;
            payload.products = [
              {
                name: product.products.name,
                id: product.products.id,
                product_combination_id: product.products.product_combination_id,
                reference: product.products.reference,
                ean_no: product.products.ean_no,
                brand: product.products.brand,
                category: product.products.category,
                variant: product.products.attributes,
                image: product.products.image,
                final_price: product.sales_price,
                vat: product.vat,
              },
            ];
            const response = await createPriceRules(payload);
            props.navigation.replace('PricelistEditScreen', {
              id: response?.data?.data?._id,
              name: response?.data?.data?.description,
            });
            setEmpty(rules.length === 0);
            setProductRules(rules);
            return;
          }
          const doc = {
            products: [
              {
                name: product.products.name,
                id: product.products.id,
                product_combination_id: product.products.product_combination_id,
                reference: product.products.reference,
                ean_no: product.products.ean_no,
                brand: product.products.brand,
                category: product.products.category,
                variant: product.products.attributes,
                image: product.products.image,
                final_price: product.sales_price,
                vat: product.vat,
              },
            ],
          };
          await editPriceRulesProduct.request(
            props?.route?.params?.id,
            product.products.id,
            product.products.product_combination_id,
            doc,
          );
        } catch (e) {
          Toast.show({
            text1: `${e?.response?.data?.message || 'A system error occurred'}`,
            type: 'error',
          });
          return;
        }
        if (!data) {
          setEmpty(rules.length === 0);
        }
        setProductRules(rules);
      }
    }
  };

  const showEdit = async () => {
    setIsEditMode(true);
    setLoading(true);
    setTabActive('pricelist');
    if (priceRules.data?._id) {
      const pr = { ...priceRules.data };
      setRules(pr);
      setTimeout(() => setLoading(false), 200);
    } else {
      priceRules.request(props.route.params.id).then((response) => {
        const pr = { ...response.data.data };
        setRules(pr);
        setTimeout(() => setLoading(false), 200);
      });
    }
  };

  const callback = async (data) => {
    if (data.key === 'save' && form) {
      await setAction('add');
      form.handleSubmit();
    } else if (data.key === 'edit') {
      showEdit();
    } else if (data.key === 'export') {
      exportPriceLogs();
    } else if (data.key === 'request_approval') {
      await handleNeedApproval();
    }
  };

  const exportPriceLogs = async () => {
    if (!props.route.params.id) {
      return;
    }
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const res = await exportCsv('product-price-rule-detail', {
        price_rules_id: props.route.params.id,
      });
      const key = res.data.key;
      if (!key) {
        throw new Error('Missing export key');
      }

      const maxAttempts = 48;
      const intervalMs = 2500;
      let url = '';
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        const status = await getExportStatus('product-price-rule-detail', key);
        if (status.data.data?.status === 'done') {
          url = status.data.data.url;
          break;
        }
        await sleep(intervalMs);
      }

      dispatch(showPopup({ name: 'isLoading', value: false }));
      if (url) {
        Linking.openURL(url);
      } else {
        Toast.show({
          text1: 'Export is taking longer than usual, please try again.',
          type: 'error',
        });
      }
    } catch (e) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: 'Something Wrong, please try again.',
        type: 'error',
      });
    }
  };

  const bindSubmitForm = (val) => (form = val);

  const onDelete = () => {
    dispatch(
      showAlert({
        show: true,
        title: 'Delete Price List',
        description: 'This price list will be deleted. Do you want to proceed?',
        isConfirm: true,
        onCallback: async () => {
          if (priceRules?.data?._id) {
            await deletePriceRule(priceRules.data._id);
            props.navigation.navigate('PricelistScreen');
          }
        },
      }),
    );
  };

  const changeMenu = () => {
    if (props.notification) {
      setIsAddMode(false);
      setIsEditMode(false);
      setTabActive('pricelist');
      setTabActiveApps('detail');
      return;
    }
    let menu = [
      { type: 'props', name: 'Edit', key: 'edit' },
      { type: 'props', name: 'Export Price Log', key: 'export' },
    ];

    if (priceRules?.data?.status === 'draft') {
      menu.push({
        type: 'props',
        name: 'Request Approval',
        key: 'request_approval',
      });
    }

    if (!showAddEdit) {
      menu.splice(0, 1);
    }
    if (isEditMode || isAddMode) {
      menu = [{ type: 'props', name: 'Save', key: 'save' }];
    }

    if (showDelete && !isWeb) {
      menu.push({ type: 'function', name: 'Delete', callback: onDelete });
    }

    props.navigation.setOptions({
      headerRight: () => {
        return isWeb ? (
          <NotificationSettingButton {...props} />
        ) : (
          <MoreButton menu={menu} callback={(value) => callback(value)} />
        );
      },
    });
  };

  const addProduct = () => {
    setProduct(null);
    dispatch(showPopup({ name: 'productPriceRules', value: true }));
  };

  const onImport = () => {
    dispatch(
      showPopup({
        name: 'showImportModalAddProductPriceList',
        value: true,
      }),
    );
  };

  const handleImport = async (url) => {
    try {
      await bulkAddProductPriceRules(props.route.params.id, { url });
      Toast.show({
        text1: 'Bulk Add Product Pricelist is in progress',
        type: 'success',
      });
    } catch (error) {
      Toast.show({
        text1:
          error?.response?.data?.message ||
          'Something Wrong, please try again.',
        type: 'error',
      });
    }
    dispatch(
      showPopup({
        name: 'showImportModalAddProductPriceList',
        value: false,
      }),
    );
  };

  useEffect(() => {
    changeMenu();
  }, [isAddMode, isEditMode, priceRules?.data?.status]);

  useEffect(() => {
    console.log(prev_page);
    setDisabled(false);
    if (props.notification) {
      priceRules.updateData(props.detailPriceRules);
    } else {
      setProductRules([]);
      if (props.route?.params?.id) {
        setIsAddMode(false);
        setTabActive('pricelist');
        setTabActiveApps('detail');
        setPage(1);
        priceRules.request(props.route.params.id);
      }
      props.navigation.addListener('blur', () => {
        setIsEditMode(false);
      });
      return function cleanup() {
        props.navigation.removeListener('blur');
      };
    }
  }, [props]);

  return (
    <Layout.Container>
      {isWeb && !props.notification && (
        <TouchableOpacity
          style={backSection}
          activeOpacity={0.6}
          onPress={() => goBack()}>
          <Image
            style={{ width: 7, height: 12, marginRight: 15 }}
            width={7}
            height={12}
            svg={true}
            source={require('@assets/img/icons/arrow-left-grey.svg')}
          />
          <SociollaText style={backSectionText}>
            Back to {prev_page === 'task' ? 'Task' : 'pricelist'}
          </SociollaText>
        </TouchableOpacity>
      )}
      <View
        style={[
          styles.container,
          props.notification
            ? { margin: isWeb ? -30 : 0, flexDirection: 'column', flex: 1 }
            : {},
          showStickyButton
            ? {
                paddingBottom: 130,
              }
            : {},
        ]}>
        {loading ? (
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="large" color={Colors.blue0} />
          </View>
        ) : (
          <SociollaForm
            initialValues={{
              description: isEditMode ? rules.description || '' : '',
              currency: isEditMode ? rules.currency || '' : '',
              taxes_type: isEditMode ? rules.taxes_type || '' : '',
              market_type: isEditMode ? rules.market_type || '' : '',
              from_date: isEditMode ? changeTimeZone(rules.from_date) : '',
              to_date: isEditMode ? changeTimeZone(rules.to_date) : '',
              is_default: isEditMode ? rules.is_default || false : false,
              is_consignment: isEditMode
                ? rules.is_consignment || false
                : false,
            }}
            bindSubmitForm={bindSubmitForm}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            innerRef={(formik) => (form = formik)}>
            <View
              style={[
                styles.leftContainer,
                props.notification ? { width: '100%' } : {},
              ]}>
              {isWeb && (isAddMode || isEditMode) && (
                <View style={styles.headerContainer}>
                  <SociollaText
                    type="medium"
                    color="#171D29"
                    style={{ marginBottom: 40, fontSize: 24 }}>
                    Pricelist
                  </SociollaText>
                  <View style={styles.actionContainer}>
                    {isEditMode && (
                      <SociollaSubmitButton
                        buttonStyle={{
                          ...buttonPrimary,
                          ...buttonRounded,
                          width: 110,
                        }}
                        disabledStyle={{
                          width: isWeb ? 110 : dimension.width - 40,
                        }}
                        disabled={disabled}
                        title={
                          <SociollaText type="medium" style={styles.textAction}>
                            Save
                          </SociollaText>
                        }
                        onPress={() => setAction('add')}
                      />
                    )}
                  </View>
                </View>
              )}
              {!isWeb && [
                isAddMode || isEditMode ? (
                  <ProgressBar
                    key="progress-bar"
                    page={page}
                    totalPage={totalPage}
                  />
                ) : (
                  <SociollaTabs
                    style={{
                      borderTopWidth: 1,
                      borderTopColor: Colors.grey9,
                      paddingTop: 5,
                      marginHorizontal: -20,
                      backgroundColor: Colors.white,
                    }}
                    headerStyle={{}}
                    data={tabsApps}
                    tabActive={tabActiveApps}
                    setTabActive={(val) => setTabActiveApps(val)}
                    key="header-edit"
                  />
                ),
              ]}
              {!isWeb && tabActiveApps === 'product' && (
                <StatusPicker
                  options={tabs}
                  labelKey="label"
                  trackBy="value"
                  value={tabActive}
                  onChange={(value) => setTabActive(value.value)}
                  containerStyle={{
                    paddingTop: 16,
                    paddingLeft: 12,
                    backgroundColor: Colors.white,
                  }}
                  itemStyle={{ width: 120 }}
                />
              )}
              <View style={styles.detailContainer}>
                {!isAddMode && !isEditMode && isWeb && !props.notification && (
                  <View style={styles.headerContainer}>
                    <SociollaText
                      type="medium"
                      color="#171D29"
                      style={{ marginBottom: 40, fontSize: 24 }}
                      numberOfLines={4}>
                      {props.route.params.name || priceRules.data.description}
                    </SociollaText>
                    <View style={{ display: 'flex', flexDirection: 'column' }}>
                      <View style={styles.actionContainer}>
                        {showAddEdit && (
                          <Button
                            buttonStyle={{
                              ...buttonPrimary,
                              ...buttonRounded,
                              width: 110,
                              marginLeft: 5,
                            }}
                            title={
                              <SociollaText
                                type="medium"
                                style={styles.textAction}>
                                Edit
                              </SociollaText>
                            }
                            onPress={() => showEdit()}
                          />
                        )}
                        <Button
                          buttonStyle={{
                            ...buttonPrimary,
                            ...buttonRounded,
                            width: 173,
                            marginLeft: 5,
                          }}
                          title={
                            <SociollaText
                              type="medium"
                              style={styles.textAction}>
                              Export Price Log
                            </SociollaText>
                          }
                          onPress={() => exportPriceLogs()}
                        />
                        {showDelete && (
                          <Button
                            buttonStyle={{
                              ...buttonPrimary,
                              ...buttonRounded,
                              width: 110,
                              marginLeft: 5,
                            }}
                            title={
                              <SociollaText
                                type="medium"
                                style={styles.textAction}>
                                Delete
                              </SociollaText>
                            }
                            onPress={onDelete}
                          />
                        )}
                        {showApproval && (
                          <>
                            <Button
                              buttonStyle={{
                                ...buttonPrimary,
                                ...buttonRounded,
                                width: 110,
                                backgroundColor: Colors.white,
                                borderColor: Colors.grey0,
                                marginLeft: 5,
                              }}
                              title={
                                <SociollaText
                                  type="medium"
                                  style={{
                                    ...styles.textAction,
                                    color: Colors.black,
                                  }}>
                                  Reject
                                </SociollaText>
                              }
                              onPress={() => updateStatus('rejected')}
                            />
                            <Button
                              buttonStyle={{
                                ...buttonPrimary,
                                ...buttonRounded,
                                width: 110,
                                backgroundColor: Colors.blue0,
                                marginLeft: 5,
                              }}
                              title={
                                <SociollaText
                                  type="medium"
                                  style={styles.textAction}>
                                  Approve
                                </SociollaText>
                              }
                              onPress={() => updateStatus('approved')}
                            />
                          </>
                        )}
                      </View>
                      {isWeb &&
                        !isEditMode &&
                        !isAddMode &&
                        !showApproval &&
                        showAddEdit &&
                        priceRules?.data?.status === 'draft' && (
                          <View
                            style={[styles.actionContainer, { marginTop: 8 }]}>
                            <SociollaSubmitButton
                              buttonStyle={{
                                ...buttonPrimary,
                                ...buttonRounded,
                                width: showDelete ? 400 : 300,
                                marginLeft: 5,
                                backgroundColor: Colors.blue0,
                              }}
                              disabledStyle={{
                                width: isWeb ? 270 : dimension.width - 40,
                              }}
                              disabled={disabled}
                              title={
                                <SociollaText
                                  type="medium"
                                  style={styles.textAction}>
                                  Request Approval
                                </SociollaText>
                              }
                              onPress={() => handleNeedApproval()}
                            />
                          </View>
                        )}
                    </View>
                  </View>
                )}
                {isWeb ||
                (!isWeb && tabActiveApps === 'detail' && page !== 2) ||
                (!isWeb && page === 1 && (isAddMode || isEditMode)) ? (
                  <PricelistDetail
                    isAddMode={isAddMode}
                    isEditMode={isEditMode}
                    priceRules={priceRules}
                    showStickyButton={showStickyButton}
                  />
                ) : null}
                {isWeb && (isAddMode || isEditMode)
                  ? [
                      <AddProductSection
                        onCallback={addProduct}
                        onImport={onImport}
                        key="add-product"
                      />,
                      empty && (
                        <View
                          style={{
                            alignItems: 'center',
                            marginTop: 68,
                            marginBottom: 48,
                          }}
                          key="empty-add">
                          <Image
                            style={{ width: 80, height: 80 }}
                            width={80}
                            height={80}
                            svg={true}
                            source={require('@assets/img/icons/no-product.svg')}
                          />
                          <SociollaText
                            style={{
                              fontSize: 14,
                              color: Colors.black3,
                              marginTop: 20,
                            }}>
                            No product found
                          </SociollaText>
                        </View>
                      ),
                    ]
                  : isWeb && [
                      <SociollaTabs
                        style={[
                          isWeb
                            ? { marginTop: 30 }
                            : {
                                borderTopWidth: 1,
                                borderTopColor: Colors.grey9,
                                paddingTop: 5,
                              },
                          { marginHorizontal: -20 },
                        ]}
                        itemWidth={150}
                        headerStyle={{ justifyContent: 'flex-start' }}
                        data={tabs}
                        tabActive={tabActive}
                        setTabActive={(val) => setTabActive(val)}
                        key="header-edit"
                      />,
                      empty && (
                        <View
                          style={{
                            alignItems: 'center',
                            marginTop: 68,
                            marginBottom: 48,
                          }}
                          key="empty-add">
                          <Image
                            style={{ width: 80, height: 80 }}
                            width={80}
                            height={80}
                            svg={true}
                            source={require('@assets/img/icons/no-product.svg')}
                          />
                          <SociollaText
                            style={{
                              fontSize: 14,
                              color: Colors.black3,
                              marginTop: 20,
                            }}>
                            No product found
                          </SociollaText>
                        </View>
                      ),
                    ]}
                {isWeb && tabActive === 'pricelist' && (
                  <PricelistProduct
                    style={{ marginTop: isEditMode || isAddMode ? 5 : 25 }}
                    id={
                      props.notification
                        ? priceRules.data?._id || ''
                        : props.route?.params?.id || ''
                    }
                    isEditMode={isEditMode || isAddMode}
                    setEmpty={(val) => setEmpty(val)}
                    setList={(val, index, data) =>
                      onSelectedProduct(val, index, data)
                    }
                    showSearch={true}
                    list={productRules}
                    handleProductClick={(item) => productEditHandler(item)}
                  />
                )}
                {isWeb && tabActive === 'pricelog' && (
                  <PricelistLogs
                    style={{ marginTop: 15 }}
                    id={
                      props.notification
                        ? priceRules.data?._id || ''
                        : props.route?.params?.id || ''
                    }
                  />
                )}
                {page === 2 && empty && (
                  <View
                    style={{ alignItems: 'center', marginTop: 40 }}
                    key="empty-add">
                    <Image
                      style={{ width: 80, height: 80 }}
                      width={80}
                      height={80}
                      svg={true}
                      source={require('@assets/img/icons/no-product.svg')}
                    />
                    <SociollaText
                      style={{
                        fontSize: 14,
                        color: Colors.black3,
                        marginTop: 20,
                      }}>
                      No product found
                    </SociollaText>
                  </View>
                )}
              </View>
              {(page === 2 && !empty) ||
              (!isWeb &&
                tabActive === 'pricelist' &&
                tabActiveApps === 'product') ? (
                <PricelistProduct
                  //style={{ flex: 1 }}
                  id={
                    props.notification
                      ? priceRules.data?._id || ''
                      : props.route?.params?.id || ''
                  }
                  isEditMode={isEditMode || isAddMode}
                  setEmpty={(val) => setEmpty(val)}
                  setList={(val, index, data) =>
                    onSelectedProduct(val, index, data)
                  }
                  list={productRules}
                />
              ) : null}
              {(page === 2 && !empty) ||
              (!isWeb &&
                tabActive === 'pricelog' &&
                tabActiveApps === 'product') ? (
                <PricelistLogs
                  //style={{ flex: 1 }}
                  id={
                    props.notification
                      ? priceRules.data?._id || ''
                      : props.route?.params?.id || ''
                  }
                />
              ) : null}
              {!isWeb && (isAddMode || isEditMode) && (
                <View
                  style={[
                    buttonFloating,
                    {
                      borderTopColor: Colors.grey4,
                      marginBottom: isAndroid ? 30 : 20,
                      flex: 1,
                    },
                  ]}>
                  {page == 1 && (
                    <SociollaSubmitButton
                      buttonStyle={buttonRounded}
                      title={
                        <SociollaText
                          type="bold"
                          style={{
                            fontSize: 14,
                            letterSpacing: 0.5,
                            color: Colors.white,
                          }}>
                          Next
                        </SociollaText>
                      }
                      onPress={() => setAction('next')}
                    />
                  )}
                  {page == 2 && (
                    <View>
                      <AddProductSection
                        isMobile
                        onCallback={addProduct}
                        onImport={onImport}
                      />
                    </View>
                  )}
                </View>
              )}
            </View>
            {isWeb && !props.notification && (
              <View style={styles.rightContainer} />
            )}
          </SociollaForm>
        )}
      </View>
      {(productPriceRulesList || productPriceRules) && (
        <ModalProduct
          onSubmit={(val, index, data) => onSelectedProduct(val, index, data)}
          product={product}
        />
      )}
      {showImportModalAddProductPriceList ? (
        <ModalUpload
          testID="add-product-pricelist"
          show={showImportModalAddProductPriceList}
          onClose={() =>
            dispatch(
              showPopup({
                name: 'showImportModalAddProductPriceList',
                value: false,
              }),
            )
          }
          templateUrl={templateCsv}
          onUpload={handleImport}
          autoUploadS3={true}
          name={'add_product_pricelist'}
          validHeader={['vat', 'reference', 'price']}
        />
      ) : (
        false
      )}
      {!isWeb && showStickyButton ? (
        <Layout.ButtonSticky
          show={showStickyButton}
          route={props?.route}
          buttons={[
            {
              title: 'Reject',
              type: 'default',
              onPress: () => updateStatus('rejected'),
            },
            {
              title: 'Approved',
              onPress: () => updateStatus('approved'),
            },
          ]}
        />
      ) : (
        false
      )}
    </Layout.Container>
  );
}

const styles = StyleSheet.create({
  actionContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  container: {
    flexDirection: isWeb ? 'row' : 'column',
    backgroundColor: isWeb ? '' : Colors.white,
    flex: 1,
  },
  detailContainer: {
    backgroundColor: Colors.white,
    borderRadius: 4,
    paddingHorizontal: 20,
    paddingVertical: isWeb ? 20 : 0,
    paddingTop: isWeb ? 20 : 10,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 4,
  },
  leftContainer: {
    width: isWeb ? '75%' : '100%',
    flex: 1,
  },
  loadingContainer: {
    alignItems: 'center',
    marginVertical: 40,
    flex: 1,
  },
  productHeader: {
    backgroundColor: Colors.grey3,
    height: 56,
    marginHorizontal: -20,
    paddingHorizontal: 20,
    marginTop: 30,
    justifyContent: 'space-between',
  },
  rightContainer: {
    width: isWeb ? '25%' : '100%',
    paddingLeft: isWeb ? 30 : 0,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textAction: {
    fontSize: 14,
    color: Colors.white,
    paddingHorizontal: 10,
  },
});

export default PricelistDetailScreen;
